<template>
    <router-view
      :contacts_view="contacts_view"
    />
</template>

<script setup>
  const props = defineProps({
    contacts_view : {},
  });
</script>